import FlexPane from 'presentation/components/flex-pane';
import Button from 'presentation/components/button/index.js';
import { range } from 'mojito/utils';

export default function SwiperPagination(props) {
    const {
        dotCount,
        activeIndex,
        onSelect,
        mojitoTools: { config },
    } = props;

    return (
        <FlexPane class={'ta-Swiper-Pagination'} config={config.container}>
            {range(dotCount).map(index => (
                <Button
                    key={index}
                    class={'ta-Swiper-PaginationDot'}
                    config={index === activeIndex ? config.activeDot : config.dot}
                    onClick={() => onSelect(index)}
                />
            ))}
        </FlexPane>
    );
}
